
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import Grid from '../../Grid';
import Button from '../../Button';
import UserInput from '../../UserInput';

import styles, { mainCls } from '../style';
import InputField from '../../InputField';


const useStyles = createStyle(styles);

const propTypes = {
  device: PropTypes.string,
  currentUrl: PropTypes.string,
  mobileOs: PropTypes.string,
  portalDomain: PropTypes.string,
  accountDomain: PropTypes.string,
  authBasePrefix: PropTypes.string,
  logIn: PropTypes.func,
  onLogInComplete: PropTypes.func,
  postLoginAction: PropTypes.func,
  cookiesConfig: PropTypes.object,
  authBasePrefix: PropTypes.string,
};
const defaultProps = {
  device: null,
  currentUrl: '/',
  mobileOs: null,
  portalDomain: 'https://www.casa.it',
  accountDomain: 'https://www.casa.it',
  logIn: null,
  onLogInComplete: null,
  postLoginAction: null,
  cookiesConfig: {},
  authBasePrefix: '/my',
};

const LoginUnregisteredLandingInterface = ({
  device,
  accountDomain,
  storeLoginData,
  validateLoginData,
  removeError,
  doLogin,
  messageLoginError,
  loginError,
  loggingIn,
  validationErrors,
  email,
  authBasePrefix,
}) => {
  // const accountDomain = "http://localhost:3002" // DA TOGLIERE
  const isDesktop = device === 'desktop';

  const cls = useStyles();
  const baseCssClass = mainCls;
  const subClass = `${mainCls}__loginunrgstrd`;


  const mycasaCssClass = `${baseCssClass}__mycasa`;
  const ctnClass = makeClassName([
    cls[mainCls],
    'pt--m',
    'tp-a--c',
  ]);

  const mycasaForgotClass = makeClassName([
    `${mycasaCssClass}__forgot`,
    `${subClass}__forgot`,
  ]);
  const mycasaForgotLinkClass = makeClassName([
    'tp-w--m',
    isDesktop ? 'tp-s--s' : 'tp-s--m',
    `${subClass}__forgot_link`,

  ]);

  const clsFormCnt = makeClassName([
    `${mycasaCssClass}__form_cnt`,
    'm--s',
  ]);

  const clsLoginButton = makeClassName([
    cls[mainCls],
    `${subClass}__login_btn`,
  ]);

  const formWithEmail = () => {
    return (
      (
        <section className={clsFormCnt}>
          <UserInput
            type="email"
            name="email"
            disabled
            email={email}
            className={`${mycasaCssClass}__input`}
            placeholder={email}
            value={email}
            onChange={storeLoginData}
            onBlur={validateLoginData}
            onFocus={removeError}
            error={validationErrors.indexOf('email') > -1}
            errorMsg={!loginError && 'Devi inserire un indirizzo email valido'}
          />
          <UserInput
            type="password"
            name="password"
            className={`${mycasaCssClass}__input`}
            placeholder="Inserisci la password"
            onChange={storeLoginData}
            onBlur={validateLoginData}
            onFocus={removeError}
            error={validationErrors.indexOf('password') > -1}
            errorMsg={!loginError && 'La password è obbligatoria'}
          />
          {
            messageLoginError && <p className={`${baseCssClass}__mycasa__loginerror mb--m tp-s--xs tp-w--m`}>{messageLoginError}</p>
          }
          <div className={mycasaForgotClass}>
            <a
              href={`${accountDomain}${authBasePrefix}/password-dimenticata`}
              title="Recupera la tua password"
              className={mycasaForgotLinkClass}
            >
              Password dimenticata?
            </a>
          </div>
          <Button
            className={`${clsLoginButton} tp-w--l`}
            action={doLogin}
            loading={loggingIn}
          >
            Accedi
          </Button>
          <Grid className="" noWrap align="center" direction="column">
            <a
              className="tp-w--m tp-s--m tp--u mt--m mb--s c-txt--f2"
              href="/"
            >
              Non ora
            </a>
          </Grid>

        </section>
      )
    );
  }


  return (

    <Grid
      direction="column"
      className={ctnClass}
    >
      {formWithEmail()}

    </Grid>

  );
};
LoginUnregisteredLandingInterface.propTypes = propTypes;
LoginUnregisteredLandingInterface.defaultProps = defaultProps;
export default LoginUnregisteredLandingInterface;